






# import settings from '@/settings'
import nav_bar from '@/components/nav_bar'
import menu_left from '@/components/menu_left'

export default {
    name: 'menus'

    components: {
        nav_bar, menu_left
    }

    props: {
        change_distribution:{
            required: false
            type: Boolean
        }
    }

    # data: ()->

    # "methods":
 
    # mounted: ()->
}

